

















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {STATIC_COMPANY_DATA} from '@/companydata';
import {Prop} from 'vue-property-decorator';
import {NAVI_SERVICE_INSTANCE} from '@/services/navi.service';
import {DisguiseRoute} from '@/routetype';
import {
  BreadCrumbNavigateEventType,
  SubmenuClosePayload,
  SubMenuConfig,
  VuetifyBreadcrumbItemType
} from '@/interfaces/submenu.interface';
import {DOCUMENT_SCROLL_SERVICE_INSTANCE} from '@/services/documentscroll.service';
import AmetrasReactiveTabBar, {AmetrasResponsiveTabBarItem} from '@/views/pageskeleton/AmetrasResponsiveTabBar.vue';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import {isMatch, merge} from 'lodash';
import {CompositeKeyType} from '@/interfaces/key.interface';
import {BehaviorSubject} from 'rxjs';
import {v1 as generateUUID} from 'uuid';
import {DIALOG_STACK_INSTANCE, DialogInstance} from '@/utils/dialog.stack';

@Component({
  name: 'sub-menu-template',
  components: {AmetrasReactiveTabBar}
})
export default class SubMenuTemplate extends Vue implements DialogInstance {

  @Prop() subMenuConfig!: SubMenuConfig;
  showDialog: boolean = false;
  showQuickLink: boolean = false;
  routes: DisguiseRoute[] = [];
  company = STATIC_COMPANY_DATA;
  activeTabIndex: number = 0;
  previousTabIndex: number = 0;
  originalDocumentScrollXOffset: number = 0;
  // an increase of this number indicates a necessary rerending of the component in the content section
  componentRenderKeyCount: number = 0;

  subMenu: {
    breadcrumbs: VuetifyBreadcrumbItemType[],
    title: string,
    tabRoutes?: DisguiseRoute[],
    tabs?: AmetrasResponsiveTabBarItem[],
    userRequestedReloadSubjects?: Array<BehaviorSubject<string>>
  } = {
    breadcrumbs: [],
    title: ''
  };

  quickLinkSubmenu: SubMenuConfig | null = null;
  initialRenderingComplete: boolean = false;

  /**
   * Updates the context parameter and finally re-renders the submenu
   */
  updateContextParameter(newContextParameters: CompositeKeyType) {
    if (this.subMenuConfig) {

      /*
         merge ONLY if
         - there is no context param yet
         - the new partial update is not already defined with the same values in the current context params
           e.g.
           current:
           {
             companyNo: 1
             articleNo: 123
           }
           newContextParameters:
           {
             articleNo: 123
           }
           -> will NOT trigger any update

           newContextParameters:
           {
             articleNo: 1234
           }
           -> will trigger the update
       */
      if (!this.subMenuConfig.contextParameter || !isMatch(this.subMenuConfig.contextParameter, newContextParameters)) {
        merge(this.subMenuConfig.contextParameter, newContextParameters);
        this.componentRenderKeyCount++; // re-render
      }
    }
  }

  onHoverMenuButton() {
    if (this.initialRenderingComplete && !this.$store.state.navigation.show) {
      this.$store.commit('showNavigation');
    }
  }

  closeSubMenu() {
    this.showQuickLink = false;
    this.updateActiveTabIndex(this.previousTabIndex);
  }

  userChangedTab() {
    if (this.subMenu && this.subMenu.tabRoutes && this.subMenu.tabRoutes[this.activeTabIndex]) {
      const newSelectedTab = this.subMenu.tabRoutes[this.activeTabIndex];
      const isQuickLink = newSelectedTab.meta?.quickLink;
      if (isQuickLink) {
        this.quickLinkSubmenu = {
          title: newSelectedTab.meta?.naviText || '',
          url: NAVI_SERVICE_INSTANCE.API_PATH_SUBMENUS + '/' + newSelectedTab.meta?.id,
          contextParameter: this.subMenuConfig.contextParameter,
          breadcrumbs: this.subMenu.breadcrumbs,
          zIndex: (this.subMenuConfig.zIndex || 100) + 1
        };
        this.showQuickLink = true;
      } else {
        this.previousTabIndex = this.activeTabIndex;
      }
      if (this.subMenu && this.subMenu.userRequestedReloadSubjects && this.subMenu.userRequestedReloadSubjects[this.activeTabIndex]) {
        this.subMenu.userRequestedReloadSubjects[this.activeTabIndex].next(generateUUID());
      }
    }
  }

  close() {
    const closeData: SubmenuClosePayload = {
      closeData: this.subMenuConfig.closeData
    };
    this.$emit('close', closeData);
  }

  created() {
    NAVI_SERVICE_INSTANCE.loadSubNavi(this.subMenuConfig.url).then((response) => {
      setTimeout(() => {
        // delays the activation of the hover function of the burger/menu button
        this.initialRenderingComplete = true;
      }, 200);

      const parent = (response.data.navi || [])[0];
      const startId = response.data.startId;

      const children = parent.children || [];
      this.routes = NAVI_SERVICE_INSTANCE.convertNaviEntriesToDisguiseRoutes(
          children,
          this.subMenuConfig.contextParameter
      );
      this.subMenu = {
        breadcrumbs: [],
        title: parent.name || '',
        tabRoutes: [],
        tabs: [],
        userRequestedReloadSubjects: []
      };
      this.showDialog = true;
      DIALOG_STACK_INSTANCE.registerDialog(this);
      // breadcrumbs
      this.subMenu.breadcrumbs = (this.subMenuConfig.breadcrumbs || []).slice(0);
      this.subMenu.breadcrumbs.push({
        text: parent.name || '',
        id: parent.id
      });
      this.subMenu.tabRoutes = [];
      for (const route of this.routes) {
        this.subMenu.tabRoutes?.push(route);
        this.subMenu.tabs?.push({
          text: route.meta?.naviText ? route.meta?.naviText : '',
          title: route.meta?.naviText ? route.meta?.naviText : '',
          icon: route.meta?.quickLink ? 'link' : undefined
        });
        this.subMenu.userRequestedReloadSubjects?.push(new BehaviorSubject<string>(''));
      }

      if (startId !== undefined && this.subMenu.tabRoutes) {
        let tabIndex;
        for (let currentTabIndex = 0; currentTabIndex < this.subMenu.tabRoutes.length; currentTabIndex++) {
          const currentTab = this.subMenu.tabRoutes[currentTabIndex];
          if (startId === currentTab.meta?.id) {
            tabIndex = currentTabIndex;
            break;
          }

          const quickLink = children.find((x) => x.id === startId);
          if (quickLink && quickLink.naviType && quickLink.naviType['@type'] === 'QUICK_LINK') {
            this.quickLinkSubmenu = {
              title: quickLink.name || '',
              url: NAVI_SERVICE_INSTANCE.API_PATH_SUBMENUS + '/' + quickLink.naviType.linkId || '',
              contextParameter: this.subMenuConfig.contextParameter,
              breadcrumbs: this.subMenu.breadcrumbs,
              zIndex: (this.subMenuConfig.zIndex || 100) + 1
            };

            this.showQuickLink = true;
            this.previousTabIndex = this.activeTabIndex;
            this.previousTabIndex = 0;
          }

        }
        if (tabIndex === undefined) {
          throw new Error('TabIndex for given startId not found.');
        } else {
          this.updateActiveTabIndex(tabIndex);
        }
      }

    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'Submenu konnte nicht geladen werden.',
          color: 'error'
        });
      }
    });
  }

  destroyed() {
    DIALOG_STACK_INSTANCE.unregisterDialog(this);
  }

  mounted() {

    Vue.nextTick(async () => {
      // wait till the transition has finished
      await new Promise((r) => setTimeout(r, 300));
      this.originalDocumentScrollXOffset =
          DOCUMENT_SCROLL_SERVICE_INSTANCE.readCurrentDocumentScrollXPosition();
      DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(0);
    });
  }

  updateActiveTabIndexToNaviId(naviId: number) {
    if (this.subMenu.tabRoutes) {
      let newTabIndex;
      for (let currentTabIndex = 0; currentTabIndex < this.subMenu.tabRoutes.length; currentTabIndex++) {
        const currentTab = this.subMenu.tabRoutes[currentTabIndex];
        if (naviId === currentTab.meta?.id) {
          newTabIndex = currentTabIndex;
          break;
        }
      }

      if (newTabIndex === undefined) {
        throw new Error('TabIndex for given naviId not found.');
      } else {
        this.updateActiveTabIndex(newTabIndex);
      }
    }
  }

  updateActiveTabIndex(newIndex: number) {
    this.activeTabIndex = newIndex;
    this.componentRenderKeyCount++;
  }

  navigateTo(id: number) {
    this.$emit('breadcrumb-navigate-to', {id});
  }

  // If title does not match, we can close the dialog and propagate the event to the parent of this component.
  // Thus all children with non-matching titles will be closed till we reach the sub menu with the matching title.
  handleBreadcrumbEvent(event: BreadCrumbNavigateEventType, submenu: SubMenuConfig) {
    if (submenu.id !== event.id) {
      this.showQuickLink = false;
      this.navigateTo(event.id);
    }
  }

  emitClose() {
    this.restoreScroll();
    this.showDialog = false;
    DIALOG_STACK_INSTANCE.unregisterDialog(this);
    this.$emit('revert');
    this.close();
  }

  restoreScroll() {
    DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(this.originalDocumentScrollXOffset);
  }

  shouldHideOverlay(): void {
    // do nothing
  }
  shouldRestoreHideOverlay(): void {
    // do nothing
  }

}
